import { Alert, Button } from '@indipia/ui-core'
import { ORDER_MESSAGE } from '../constants/materialOrder.logic'

const MSG = ORDER_MESSAGE.settings

// 설정 화면 공통 하단 저장줄 — 바꾼 공종 수 · 저장 (WP5 W5-27, 승격 후보)
export interface SettingsSaveBarProps {
  changedCount: number
  saving: boolean
  saved: boolean
  /** 저장 실패 문구(없으면 오류 없음) */
  error?: string | null
  /** 저장 대상에서 제외된 개수 안내(0이면 숨김) */
  skippedNotice?: string | null
  onSave: () => void
}

export function SettingsSaveBar({ changedCount, saving, saved, error, skippedNotice, onSave }: SettingsSaveBarProps) {
  const none = changedCount === 0
  return (
    <div className="sticky bottom-0 border-t border-border bg-surface px-4 py-3">
      {error && (
        <Alert kind="error" className="mb-2" role="alert">{error}</Alert>
      )}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex flex-col gap-1">
          <span className="text-body-sm font-bold">{none ? MSG.noChange : MSG.changed(changedCount)}</span>
          {skippedNotice && <span className="text-caption text-hint">{skippedNotice}</span>}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-caption text-hint" aria-live="polite">
            {saving ? MSG.saving : saved ? MSG.saved : ''}
          </span>
          <Button variant="primary" disabled={none} loading={saving} onClick={onSave}>저장</Button>
        </div>
      </div>
    </div>
  )
}
